import "helpers/initFA";

import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import Main from "./Main";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SettingContextProvider } from "context/SettingContext";
import { ProfileProvider } from "context/ProfileContext";
import { PermissionProvider } from "context/PermissionContext";

const container = document.getElementById("main");
const root = createRoot(container);
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Main>
        <SettingContextProvider>
          <PermissionProvider>
            {/* <ProfileProvider> */}
            <App />
            {/* </ProfileProvider> */}
          </PermissionProvider>
        </SettingContextProvider>
      </Main>
    </QueryClientProvider>
  </React.StrictMode>,
);
